import { isEmpty } from './utility'
import { useLangStore } from '@/stores/app/lang'
import { usePageStore } from '@/stores/app/page'
import { usePopupStore } from '@/stores/popup'

// -----------------------------------------------
export function baseUrl(path = '') {
  return (import.meta.env.BASE_URL + path).replace(/\/\//g, '/')
}

// -----------------------------------------------
export function langUrl(path, lang = null) {
  return baseUrl(path.replace(/\b\/(?:th|en|xx)\/\b/gi, `/${!isEmpty(lang) ? lang : useLangStore().lang}/`))
}

// -----------------------------------------------
export function changePage(name, forceRefresh = false) {
  usePageStore().changePage(name, forceRefresh)
}

export function refreshPage() {
  usePageStore().refreshPage()
}

// -----------------------------------------------
export function openPopup(name) {
  usePopupStore().openPopup(name)
}

export function closePopup() {
  usePopupStore().closePopup()
}

// -----------------------------------------------
export function getFilePrefix(item) {
  return item.place + '-' + item.category + '-' + item.order
}

// -----------------------------------------------
